export default class DataManager
{
    constructor()
    {
    }
}